import React from "react";

import Form, { Row } from "2g-form";
import PageHeading from "2g-page-heading";

import * as AC from "b2b/components/autocompletes";

const renderAC = (key, props) => {
  const AcRenderer = AC[key];
  return (
    <Row>
      <AcRenderer
        label={`${key} ${JSON.stringify(props) || ""}`}
        path={key}
        {...props}
      />
      <AcRenderer
        label={`${key} - multiple ${JSON.stringify(props) || ""}`}
        path={`${key}Multiple`}
        multiple
        {...props}
      />
    </Row>
  );
};

export function AutocompletesExample() {
  return (
    <>
      <PageHeading>Číselníky</PageHeading>
      <Form moduleKey="acExample">
        {renderAC("ACDoplnkoveSluzby")}
        {renderAC("ACProdukty")}
        {renderAC("ACZakaznikSmlouvy", { zakaznikICO: 152354851 })}
        {renderAC("ACZadostiStav", { zakaznikICO: 152354851 })}
        {renderAC("ACZakaznici")}
        {renderAC("ACZakaznikProjekty", { zakaznikICO: 152354851 })}
        {renderAC("ACZakaznikUzivatele", { zakaznikICO: 152354851 })}
        {renderAC("ACZdroje", { zakaznikICO: 152354851 })}
      </Form>
    </>
  );
}

export default React.memo(AutocompletesExample);
